




































import Vue from 'vue'
import { ApiResponse, Contact } from '@/interfaces'

interface DropdownAction {
  action: string
  contact?: Contact
}

export default Vue.extend({
  name: 'ContactsTable',
  props: {
    contacts: {
      type: Array,
      required: false,
      default: () => [] as Contact[],
    },
    view: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    getTypeIcon(type: string): string {
      switch (type) {
        case 'personne_physique':
          return 'contact-type-icon el-icon-user'

        case 'personne_morale':
          return 'contact-type-icon el-icon-suitcase-1'

        default:
          return 'contact-type-icon el-icon-question'
      }
    },
    handleContactCommand(command: DropdownAction) {
      // Restore contact
      if (command.action == 'restore' && command.contact) {
        this.restoreContact(command.contact)
      }

      // Delete contact permanently
      if (command.action == 'delete_permanently' && command.contact) {
        this.deleteContactPermanently(command.contact)
      }
    },
    restoreContact(contact: Contact) {
      this.$api
        .put(`/contact/${contact.id}/restore`)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: 'Opération réalisée avec succès !',
          })

          this.$emit('getContacts')
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Erreur',
            message: 'Une erreur est survenue. Merci de reéssayer plus tard.',
          })
        })
    },
    deleteContactPermanently(contact: Contact) {
      this.$confirm(
        'Êtes-vous sûr(e) de vouloir supprimer ce contact ? Attention, cette opération est irréversible.',
        'Confirmation',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .delete(`/contact/${contact.id}/permanent`)
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Succès',
              message: 'Opération réalisée avec succès !',
            })

            this.$emit('getContacts')
          })
          .catch((error) => {
            if (error.response) {
              const apiResponse = error.response.data as ApiResponse
              this.$notify({
                type: 'error',
                title: 'Erreur',
                message:
                  apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
              })
            }
          })
      })
    },
    goToContact(row: Contact, column: Record<string, string>, cell: HTMLTableCellElement) {
      if (!cell.classList.contains('actions') && row.id) {
        this.$router.push({
          name: 'contact_edit',
          params: {
            id: row.id.toString(),
          },
        })
      }
    },
  },
})
